"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxItem = void 0;
const checkbox_1 = require("client/components/ui/checkbox");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./checkbox-item.less");
let CheckboxItem = class CheckboxItem extends react_1.Component {
    render() {
        const { checked, item, onHandleClick } = this.props;
        const selected = checked ? "selected" : "";
        return (React.createElement("div", { className: `checkbox-item ${selected}`, onClick: (event) => {
                onHandleClick(item);
            } },
            React.createElement(checkbox_1.UiCheckbox, { checked: checked, fill: "#ffffff", onChange: () => 0 }),
            React.createElement("span", { className: "label" }, item.label)));
    }
};
CheckboxItem = __decorate([
    mobx_react_1.observer
], CheckboxItem);
exports.CheckboxItem = CheckboxItem;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/checkbox-group/checkbox-item/checkbox-item.tsx
// module id = 3626
// module chunks = 0